/**
 * Web store hooks.
 *
 * Every shared store is a framework-agnostic `zustand/vanilla` store, bound to
 * web's React here via `bind` (see docs/roadmap/zustand-vanilla-migration.md).
 * This decouples web's React version from shared and from mobile.
 *
 * Vanilla stores are imported from their deep module path (not the aggregate
 * `@personal-trainer-app/shared` barrel) so that tests which fully mock the
 * shared barrel don't have to also supply the vanilla store export.
 */
import { authStore } from '@personal-trainer-app/shared/src/store/auth.store';
import { calendarStore } from '@personal-trainer-app/shared/src/store/calendar.store';
import { challengeStore } from '@personal-trainer-app/shared/src/store/challenge.store';
import { customExerciseStore } from '@personal-trainer-app/shared/src/store/custom-exercise.store';
import { goalStore } from '@personal-trainer-app/shared/src/store/goal.store';
import { jobProgressStore } from '@personal-trainer-app/shared/src/store/job-progress.store';
import { listSortStore } from '@personal-trainer-app/shared/src/store/list-sort.store';
import { notificationStore } from '@personal-trainer-app/shared/src/store/notification.store';
import { planStore } from '@personal-trainer-app/shared/src/store/plan.store';
import { trainerStore } from '@personal-trainer-app/shared/src/store/trainer.store';
import { userPreferencesStore } from '@personal-trainer-app/shared/src/store/user-preferences.store';
import { workoutStore } from '@personal-trainer-app/shared/src/store/workout.store';

import { bind } from './bind';

export const useCalendarStore = bind(calendarStore);
export const useChallengeStore = bind(challengeStore);
export const useCustomExerciseStore = bind(customExerciseStore);
export const useGoalStore = bind(goalStore);
export const useWorkoutStore = bind(workoutStore);
export const useUserPreferencesStore = bind(userPreferencesStore);
export const usePlanStore = bind(planStore);
export const useAuthStore = bind(authStore);
export const useNotificationStore = bind(notificationStore);
export const useJobProgressStore = bind(jobProgressStore);
export const useListSortStore = bind(listSortStore);
export const useTrainerStore = bind(trainerStore);
